interface CoachLeaderListBehavior {
  name: string;
  phase: string;
  last_practice_date: string | null;
}

interface CoachLeaderListRowInput {
  leaderId: string;
  pendingTranscriptId?: string | null;
  behavior: CoachLeaderListBehavior | null;
  hasPendingTranscript: boolean;
  pendingTranscriptCount: number;
  newEvidenceCount: number;
}

export interface CoachLeaderListRowViewModel {
  behaviorLabel: string | null;
  phaseLabel: string | null;
  newEvidenceLabel: string | null;
  transcriptBadgeLabel: string | null;
  actionLabel: string;
  actionRoute: string;
}

import { buildCoachLeaderTranscriptReviewRoute } from "@/lib/coachTranscriptReviewRoute";

const PHASE_LABELS: Record<string, string> = {
  ACTIVE_PRACTICE: "Practicing",
  CONSOLIDATION: "Consolidating",
  SYNTHESIS: "Synthesis",
};

function pluralize(count: number, singular: string, plural: string) {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function buildCoachLeaderListRowViewModel(
  input: CoachLeaderListRowInput,
): CoachLeaderListRowViewModel {
  return {
    behaviorLabel: input.behavior?.name || null,
    phaseLabel: input.behavior ? PHASE_LABELS[input.behavior.phase] || input.behavior.phase : null,
    newEvidenceLabel:
      input.newEvidenceCount > 0
        ? `${pluralize(input.newEvidenceCount, "new evidence item", "new evidence items")}`
        : null,
    transcriptBadgeLabel:
      input.hasPendingTranscript && input.pendingTranscriptCount > 0
        ? `${pluralize(input.pendingTranscriptCount, "transcript", "transcripts")} ready for review`
        : null,
    actionLabel: input.hasPendingTranscript ? "Open transcript review" : "Open",
    actionRoute: input.hasPendingTranscript
      ? buildCoachLeaderTranscriptReviewRoute(input.leaderId)
      : `/coach/leaders/${input.leaderId}`,
  };
}
